export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceDeliveryTypes: [
        {
          serviceDeliveryTypeUuid: "servicedeliverytype002",
          deliveryTypeMstUuid: "deliverytypemst002",
          deliveryTypeId: 2,
          deliveryTypeName: "家族のお知らせ",
          deliveryType: "family_info",
          deliveryPriority: "alert",
          deliveryTypeStatus: 1
        },
        {
          serviceDeliveryTypeUuid: "servicedeliverytype003",
          deliveryTypeMstUuid: "deliverytypemst003",
          deliveryTypeId: 3,
          deliveryTypeName: "サイネージ",
          deliveryType: "signage",
          deliveryPriority: "notice",
          deliveryTypeStatus: 1
        },
        {
          serviceDeliveryTypeUuid: "servicedeliverytype004",
          deliveryTypeMstUuid: "deliverytypemst004",
          deliveryTypeId: 4,
          deliveryTypeName: "見守り",
          deliveryType: "follow",
          deliveryPriority: "notice",
          deliveryTypeStatus: 1
        }
      ]
    }
  }
}